// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page[data-v-15f9d95d]{margin-top:2px;padding:2px 0}", "",{"version":3,"sources":["webpack://./bundles/Factory/CustomAdminBundle/public/vue/modals/ReorderPagesModal.vue"],"names":[],"mappings":"AACI,uBAEI,cAAA,CADA,aACR","sourcesContent":["\n    .page\n        padding: 2px 0px\n        margin-top: 2px\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
